<template>
  <div class="con">
    <div class="loadingLayer" v-if="is_loading">
      <div class="loadingWrap">
        <!-- <Loading></Loading> -->
        <i class="fas fa-spinner fa-pulse"></i>
        <h1>로딩 중입니다.</h1>
      </div>
    </div>

    <div class="title">
      <h2>정보입력</h2>
      <p>신청을 위한 정보 입력을 해 주세요.</p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
      <div class="apply-fieldset">
        <div class="hq-table-row">
          <p class="w-100per txt-right pb-10 font-14">
            <span class="txt-red">*</span> 필수 입력 사항입니다.
          </p>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr
                v-for="(item, index) of info"
                :key="index"
                v-show="item.show == 'true'"
              >
                <th>
                  <!-- Email일때는 구분자가 E-mail@밖에 없으므로 include사용 -->
                  <span v-if="item.item_name.includes('E-mail@')">이메일</span>
                  <span v-else>{{ item.item_name }}</span>
                  <span class="txt-red" v-if="item.necessary_YN === 'Y'"
                    >*</span
                  >
                </th>
                <td v-if="item.item_name.includes('1차 소속')">
                  <select
                    id="mainCom"
                    v-model="category"
                    @change="categoryChange()"
                  >
                    <option value="">1차소속</option>
                    <option value="본사(나주)">본사(나주)</option>
                    <option value="한전아트센터">한전아트센터</option>
                    <option value="강원본부">강원본부</option>
                    <option value="경기본부">경기본부</option>
                    <option value="경남본부">경남본부</option>
                    <option value="경북본부">경북본부</option>
                    <option value="경기북부본부">경기북부본부</option>
                    <option value="경인건설본부">경인건설본부</option>
                    <option value="광주전남본부">광주전남본부</option>
                    <option value="남부건설본부">남부건설본부</option>
                    <option value="남서울본부">남서울본부</option>
                    <option value="대구본부">대구본부</option>
                    <option value="대전세종충남본부">대전세종충남본부</option>
                    <option value="데이터사이언스연구소">
                      데이터사이언스연구소
                    </option>
                    <option value="부산울산본부">부산울산본부</option>
                    <option value="서울본부">서울본부</option>
                    <option value="속초연수원">속초연수원</option>
                    <option value="수안보연수원">수안보연수원</option>
                    <option value="인재개발원">인재개발원</option>
                    <option value="인천본부">인천본부</option>
                    <option value="전력기금사업단">전력기금사업단</option>
                    <option value="전력연구원">전력연구원</option>
                    <option value="전력기자재센터">전력기자재센터</option>
                    <option value="전북본부">전북본부</option>
                    <option value="제주본부">제주본부</option>
                    <option value="중부건설본부">중부건설본부</option>
                    <option value="충북본부">충북본부</option>
                    <option value="HVDC건설본부">HVDC건설본부</option>
                  </select>
                  <select
                    id="subCom"
                    v-model="category_sub"
                    class="ml-10"
                    style="width: 170px"
                  >
                    <option value="">2차 소속</option>
                  </select>
                </td>
                <td
                  v-if="
                    item.option_info &&
                    item.option_info !== 'direct' &&
                    item.option_info !== 'descriptive'
                  "
                >
                  <!-- 라디오 -->
                  <p
                    v-if="
                      item.option_info &&
                      item.option_info !== 'direct' &&
                      item.option_info.indexOf('^') !== -1
                    "
                    class="clear"
                  >
                    <span
                      class="ml-10 flot-left"
                      v-for="(option, index) of item.option_info.split('^')"
                      :key="index"
                    >
                      <input
                        type="radio"
                        v-model="item.value"
                        :value="option"
                      />
                      {{ option }}
                    </span>
                  </p>
                  <!-- 체크박스 -->
                  <p
                    v-if="
                      item.option_info &&
                      item.option_info !== 'direct' &&
                      item.option_info.indexOf('&') !== -1
                    "
                    class="clear"
                  >
                    <span
                      class="ml-10 flot-left"
                      v-for="(option, index) of item.option_info.split('&')"
                      :key="index"
                    >
                      <input
                        type="checkbox"
                        v-model="item.checkbox[index]"
                        :value="checked"
                      />
                      {{ option }}
                    </span>
                  </p>
                  <p class="ml-10 mb-span" v-if="item.item_message">
                    {{ item.item_message }}
                  </p>
                </td>
                <td
                  v-else-if="
                    item.option_info &&
                    item.option_info !== 'direct' &&
                    item.item_name !== '이름' &&
                    item.option_info === 'descriptive'
                  "
                >
                  <!-- 서술형 -->
                  <textarea
                    id
                    class="w-100per h-100px"
                    v-model="item.value"
                    placeholder="1000자 이내로 작성하세요."
                    maxlength="1000"
                  ></textarea>
                </td>
                <td v-else>
                  <input
                    id
                    class="mb-input h-30px"
                    type="password"
                    v-if="item.item_name === '비밀번호' "
                    v-model="item.value"
                    name
                    title
                    required
                  />
                  <input
                  class="mb-input h-30px"
                  @click="openKaKaoSearchAddress(item)"
                  v-else-if="item.item_name === '주소'"
                  v-model="item.value"
                  />
                  <input
                  class="mb-input h-30px"
                  @input="formatAsPhone(item)"
                  maxlength="13" 
                  v-else-if="item.item_name === '휴대전화번호'"
                  v-model="item.value"
                  />                  
                  <input
                    id
                    class="mb-input h-30px "

                    v-else
                    v-model="item.value"
                    name
                    title
                    required
                    :readonly="
                      (item.item_name == '이름' || item.item_name.includes('E-mail@')) && is_read == 'Y'
                    "
                    :disabled=" item.item_name.includes('E-mail@')"

                    :maxlength="item.item_name == '이름' ? 15 : undefined"
                  />
                  <span v-if="item.item_name.includes('E-mail@')">
                    <span
                      v-if="item.item_name.replace('E-mail@', '').trim() === ''"
                      >{{ item.item_name.replace("E-mail@", "") }}</span
                    >
                    <span v-else>{{
                      item.item_name.replace("E-mail", "")
                    }}</span>
                  </span>
                  <span class="ml-20 mb-span" v-if="item.item_message">{{
                    item.item_message
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="apply-agree-btn">
      <button type="button" :class="setButtonColor()" @click="apply">
        신청하기
      </button>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/loading.vue";
import Select from "./select.vue";
import { log } from "logrocket";
export default {
  components: {
    Loading: Loading,
    Select,
  },
  data: () => ({
    sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
    info: [], // 사용자정보 입력을 동적으로 하기 위한 데이터 (ex 회사정보를 필수 입력란으로 정할지 말지)

    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    isRegPage: false, // 현재 페이지가 신청완료 직전 페이지인지

    pointColor: "blue",
    is_read: "N",

    is_loading: false,
    category: "",
    category_sub: "",
    isRegUser:true //현재 가입정보가 있는지체크
  }),

  watch: {
    // 등록 페이지 내의 현재 라우터 경로 감지
    // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
    $route(to) {
      if (this.$route.fullPath === "/user/reg/input") {
        this.loadSugangData();
      }
    },
  },

  mounted() {


    var readOnly = sessionStorage.getItem("is_read");

    if (readOnly == "Y") {
      this.is_read = readOnly;
    }


    this.pointColor = sessionStorage.getItem("pointColor");
    if (sessionStorage.getItem("classData")) {
      this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
    } else {
      this.sessionData = {};
    }

    // console.log("this.sessionData", this.sessionData);

    // TODO: 추후에 page idx 바꿔야함!!
    var pageIdx = sessionStorage.getItem("pageIdx");
    var params = {
      pageIdx: pageIdx,
    };
    this.axios
      .get(this.axios.root + this.axios.port + `/sugang/info/${pageIdx}`, {
        params: params,
      })
      .then((res) => {
        // console.log("res", res);
        if (res.data.err === 0) {

          for (var item of res.data.info) {
            if (item.use_YN === "Y") {
              if (item.option_info.split("^").length > 1) {
                item["value"] = item.option_info.split("^")[0];
              } else {
                item["value"] = "";
              }

              if (item.option_info.split("&").length > 1) {
                item.checkbox = [];
              }


              if (item.item_name.includes("E-mail@")) {
                item["value"] = localStorage.getItem("userId");
              }

              if (item.item_name.includes("비밀번호")&& !this.isRegUser) {
                //이미기존에 가입된 계정이라면 비밀번호는 입력하지않는다

              }else{
                this.info.push(item);
              }

            }
          }
          // console.log("this.info", this.info);
          if("Y"==res.data.isUser){
            this.isRegUser=true;
            sessionStorage.setItem("isRegUser", "Y");
          }else{
            this.isRegUser=false;
            sessionStorage.setItem("isRegUser", "N");
          }
          $.each(this.info, function (k, i) {
            switch (i.item_name) {
              case "이름":
                i.value = sessionStorage.getItem("b2b_kname");
                break;
              case "사번":
                i.value = sessionStorage.getItem("b2b_sabun");
                break;
              case "휴대전화번호":
                i.value = sessionStorage.getItem("b2b_mobile");
                break;
              default:
                break;
            }

            if (i.item_name == "비밀번호" && readOnly == "Y") {
              i.show = "false";
            } else {
              i.show = "true";
            }
          });
          // console.log("dddd2",this.info);
        } else {
          alert(res.data.result);
        }
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (finishPage === "complete") {
      if (pageType === pOrder[pOrder.length - 2]) {
        this.isRegPage = true;
      }
    }

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }
  },

  methods: {
    formatAsPhone(item) {
      let value = item.value.replace(/\D/g, ''); // 숫자만 남기기

      // 하이픈 포맷 적용
      if (value.length > 3 && value.length <= 7) {
        value = value.replace(/(\d{3})(\d+)/, '$1-$2');
      } else if (value.length > 7) {
        value = value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
      }

      // 변경된 값을 item.value에 반영
      this.$set(item, 'value', value);
    },
    openKaKaoSearchAddress(item) {
      new window.daum.Postcode({
        oncomplete: (response) => {
          item.value = response.address;
        },
      }).open();
    },
    categoryChange() {
      var 본사 = [];
      var 강원본부 = [
        "직할",
        "원주지사",
        "강릉지사",
        "홍천지사",
        "횡성지사",
        "속초고성지사",
        "철원지사",
        "삼척지사",
        "영월지사",
        "동해지사",
        "인제지사",
        "양구지사",
        "태백지사",
        "양양지사",
        "화천지사",
        "평창지사",
        "정선지사",
        "강릉전력지사",
        "동해전력지사",
        "원주전력지사",
        "태백전력지사",
      ];
      var 경기본부 = [
        "직할",
        "안양군포의왕지사",
        "안산지사",
        "성남지사",
        "오산지사",
        "평택지사",
        "화성지사",
        "광주지사",
        "서수원지사",
        "서용인지사",
        "안성지사",
        "이천지사",
        "서평택지사",
        "동용인지사",
        "여주지사",
        "하남지사",
        "광명지사",
        "성남전력지사",
        "군포전력지사",
        "동부전력지사",
      ];
      var 경기북부본부 = [
        "직할",
        "고양지사",
        "파주지사",
        "구리지사",
        "양평지사",
        "포천지사",
        "남양주지사",
        "동두천지사",
        "가평지사",
        "연천지사",
        "구리전력지사",
        "고양전력지사",
      ];
      var 경남본부 = [
        "직할",
        "진주지사",
        "마산지사",
        "거제지사",
        "밀양지사",
        "사천지사",
        "통영지사",
        "거창지사",
        "함안지사",
        "창녕지사",
        "합천지사",
        "진해지사",
        "하동지사",
        "곡성지사",
        "산청지사",
        "남해지사",
        "함양지사",
        "의령지사",
        "함안전력지사",
        "진주전력지사",
        "통영전력지사",
      ];
      var 경북본부 = [
        "직할",
        "구미지사",
        "상주지사",
        "영주지사",
        "의성지사",
        "문경지사",
        "예천지사",
        "봉화지사",
        "울진지사",
        "군위지사",
        "청송지사",
        "영양지사",
        "영주전력지사",
        "구미전력지사",
      ];
      var 경인건설본부 = ["직할", "남서울인천건설지사", "경기건설지사"];
      var 광주전남본부 = [
        "직할",
        "여수지사",
        "순천지사",
        "광산지사",
        "서광주지사",
        "목포지사",
        "나주지사",
        "해남지사",
        "고흥지사",
        "영암지사",
        "화순지사",
        "광양지사",
        "보성지사",
        "무안지사",
        "영광지사",
        "강진지사",
        "장성지사",
        "장흥지사",
        "담양지사",
        "진도지사",
        "곡성지사",
        "완도지사",
        "신안지사",
        "구례지사",
        "함평지사",
        "순천전력지사",
        "강진전력지사",
        "목포전력지사",
        "광주전력지사",
      ];
      var 남부건설본부 = ["직할", "대구경북건설지사"];
      var 남서울본부 = [
        "직할",
        "강서양천지사",
        "관악동작지사",
        "강동송파지사",
        "구로금천지사",
        "강남지사",
        "서초지사",
        "영등포전력지사",
        "동서울전력지사",
        "강남전력지사",
      ];
      var 대구본부 = [
        "직할",
        "동대구지사",
        "경주지사",
        "남대구지사",
        "서대구지사",
        "포항지사",
        "경산지사",
        "김천지사",
        "영천지사",
        "칠곡지사",
        "성주지사",
        "청도지사",
        "북포항지사",
        "고령지사",
        "영덕지사",
        "울릉지사",
        "포항전력지사",
        "달성전력지사",
        "칠곡전력지사",
        "경산전력지사",
      ];
      var 대전세종충남본부 = [
        "직할",
        "천안지사",
        "대덕유성지사",
        "아산지사",
        "서대전지사",
        "세종지사",
        "당진지사",
        "서산지사",
        "보령지사",
        "논산지사",
        "공주지사",
        "홍성지사",
        "태안지사",
        "부여지사",
        "금산지사",
        "서천지사",
        "청양지사",
        "서산전력지사",
        "천안전력지사",
        "청양전력지사",
        "대전전력지사",
        "세종전력지사",
        "예산지사",
      ];
      var 데이터사이언스연구소 = [];
      var 부산울산본부 = [
        "직할",
        "울산지사",
        "김해지사",
        "동래지사",
        "남부산지사",
        "양산지사",
        "중부산지사",
        "북부산지사",
        "서부산지사",
        "기장지사",
        "서울산지사",
        "영도지사",
        "울산전력지사",
        "북부산전력지사",
        "동부산전력지사",
        "서부산전력지사",
        "동울산지사",
      ];
      var 서울본부 = [
        "직할",
        "동대문중랑지사",
        "서대문은평지사",
        "강북성북지사",
        "광진성동지사",
        "마포용산지사",
        "노원도봉지사",
        "성동전력지사",
        "중부전력지사",
      ];
      var 속초연수원 = [];
      var 수안보연수원 = [];
      var 인재개발원 = [];
      var 인천본부 = [
        "직할",
        "남인천지사",
        "부천지사",
        "김포지사",
        "제물포지사",
        "서인천지사",
        "시흥지사",
        "강화지사",
        "영종지사",
        "백령지사",
        "부평전력지사",
        "시흥전력지사",
        "김포전력지사",
      ];
      var 전력기금사업단 = [];
      var 전력연구원 = ["대전", "나주 에너지신기술연구원"];
      var 전력기자재센터 = [];
      var 전북본부 = [
        "직할",
        "익산지사",
        "군산지사",
        "남전주지사",
        "김제지사",
        "정읍지사",
        "남원지사",
        "고창지사",
        "부안지사",
        "임실지사",
        "진안지사",
        "장수지사",
        "순창지사",
        "무주지사",
        "군산전력지사",
        "김제전력지사",
      ];
      var 제주본부 = ["직할", "서귀포지사", "제주전력지사"];
      var 중부건설본부 = [
        "직할",
        "충북강원지사",
        "전북건설지사",
        "광주전남건설지사",
      ];
      var 충북본부 = [
        "직할",
        "동청주지사",
        "충주지사",
        "제천지사",
        "진천지사",
        "증평괴산지사",
        "음성지사",
        "영동지사",
        "보은지사",
        "옥천지사",
        "단양지사",
        "청주전력지사",
        "충주전력지사",
      ];
      var 한전아트센터 = [];

      var target = document.getElementById("subCom");

      if (this.category == "본사(나주)") var sub = 본사;
      else if (this.category == "강원본부") var sub = 강원본부;
      else if (this.category == "경기본부") var sub = 경기본부;
      else if (this.category == "경기북부본부") var sub = 경기북부본부;
      else if (this.category == "경남본부") var sub = 경남본부;
      else if (this.category == "경북본부") var sub = 경북본부;
      else if (this.category == "경인건설본부") var sub = 경인건설본부;
      else if (this.category == "광주전남본부") var sub = 광주전남본부;
      else if (this.category == "남부건설본부") var sub = 남부건설본부;
      else if (this.category == "남서울본부") var sub = 남서울본부;
      else if (this.category == "대구본부") var sub = 대구본부;
      else if (this.category == "대전세종충남본부") var sub = 대전세종충남본부;
      else if (this.category == "데이터사이언스연구소")
        var sub = 데이터사이언스연구소;
      else if (this.category == "부산울산본부") var sub = 부산울산본부;
      else if (this.category == "서울본부") var sub = 서울본부;
      else if (this.category == "속초연수원") var sub = 속초연수원;
      else if (this.category == "수안보연수원") var sub = 수안보연수원;
      else if (this.category == "인재개발원") var sub = 인재개발원;
      else if (this.category == "인천본부") var sub = 인천본부;
      else if (this.category == "전력기금사업단") var sub = 전력기금사업단;
      else if (this.category == "전력연구원") var sub = 전력연구원;
      else if (this.category == "전력기자재센터") var sub = 전력기자재센터;
      else if (this.category == "전북본부") var sub = 전북본부;
      else if (this.category == "제주본부") var sub = 제주본부;
      else if (this.category == "중부건설본부") var sub = 중부건설본부;
      else if (this.category == "충북본부") var sub = 충북본부;
      else if (this.category == "한전아트센터") var sub = 한전아트센터;

      target.options.length = 0;

      for (let v in sub) {
        var opt = document.createElement("option");
        opt.value = sub[v];
        opt.innerHTML = sub[v];
        target.appendChild(opt);
      }
    },
    setButtonColor() {
      if (this.pointColor === "Blue") {
        return "blue";
      } else if (this.pointColor === "Red") {
        return "red";
      } else if (this.pointColor === "Green") {
        return "green";
      }
    },

    // 세션 스토리지 수강신청 전체 데이터 loading
    loadSugangData() {
      if (sessionStorage.getItem("classData")) {
        this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
      }
    },

    // 수강신청 하기
    apply() {
      // 깊은복사 다시해서 session에 넣는 이유
      // info.email에 그대로 @xxx.com을 추가해버리면 test@xxx.com@xxx.com 현상발생
      var info = JSON.parse(JSON.stringify(this.info));

      // console.log("this.info", this.info);
      for (var [index, item] of this.info.entries()) {
        // console.log("item", item);

        if (item.show == "false" && item.item_name == "비밀번호") {
          item.value = "carrot1321";
        }

        if (item.item_name === "이름") {
          this.sessionData["name"] = item.value;
        } else if (item.item_name === "비밀번호") {
          var eng_exp = /[^A-Za-z]/gi;
          if (!eng_exp.test(item.value)) {
            alert(
              "비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가1"
            );
            return false;
          } else {
            // var number_exp= /^[0-9]/ig
            var num_exp = /^[0-9]*$/;
            // console.log(num_exp.test(item.value))
            if (num_exp.test(item.value)) {
              alert(
                "비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가2"
              );
              return false;
            } else {
              var passRegex = /^[A-Za-z0-9+]{8,12}$/;
              if (!passRegex.exec(item.value)) {
                alert(
                  "비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가"
                );
                return false;
              }
            }
          }

          this.sessionData["password"] = item.value;
        } else if (item.item_name.includes("E-mail@")) {
          var emailRegex =
            /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;

          if (item.item_name.replace("E-mail@", "").trim() === "") {
            if (!emailRegex.exec(item.value)) {
              alert("정확한 이메일을 입력해 주세요.");
              return false;
            }
            this.sessionData["email"] = item.value;
            info[index]["value"] = item.value;
          } else {
            if (
              !emailRegex.exec(
                item.value + item.item_name.replace("E-mail", "")
              )
            ) {
              alert("정확한 이메일을 입력해 주세요.");
              return false;
            }
            this.sessionData["email"] =
              item.value + item.item_name.replace("E-mail", "");
            info[index]["value"] =
              item.value + item.item_name.replace("E-mail", "");
          }
        } else if (item.item_name === "사번") {
          this.sessionData["number"] = item.value;
        } else if (item.item_name === "휴대전화번호") {
          const phoneRegex = /^\d{3}-\d{4}-\d{4}$/; // 000-0000-0000 형식
          if (!phoneRegex.test(item.value)) {
            alert("휴대전화번호는 숫자 11자리를 정확히 입력해 주세요.");
            return false;
          }          
          this.sessionData["mobile"] = item.value;
        } else if (item.item_name === "직급") {
          this.sessionData["position"] = item.value;
        } else if (item.item_name === "공인시험점수") {
          this.sessionData["point"] = item.value;
        } else if (item.item_name === "부서") {
          this.sessionData["dept"] = item.value;
        } else if (item.item_name === "회사") {
          this.sessionData["company"] = item.value;
        } else if (item.item_name === "1차 소속/ 2차 소속") {
          item.value = this.category + "-" + this.category_sub;
        }

        if (item.option_info.indexOf("&") !== -1) {
          var temp = item.option_info.split("&");
          var checkboxIdx = 0;

          for (let idx = 0; idx < temp.length; idx++) {
            if (item.checkbox[idx] == true && checkboxIdx == 0) {
              item.value = item.value + temp[idx];
              checkboxIdx++;
            } else if (item.checkbox[idx] == true) {
              item.value = item.value + " " + temp[idx];
            }
          }
        }
        info[index]["value"] = item.value;

        if (item.necessary_YN === "Y" && (!item.value || item.value.trim() === "")) {
          if (item.item_name.includes("E-mail@")) {
            alert("이메일을 입력해주세요.");
            return false;
          } else {
            alert(item.item_name + "을(를) 입력해주세요.");
            return false;
          }
        }
      }
      this.sessionData["info"] = info;
      sessionStorage.setItem("classData", JSON.stringify(this.sessionData));

      var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
      var idx = pOrder.indexOf("input") + 1;

      // 대기자로 수강신청하는데 다음 페이지가 결제페이지인 경우
      if (sessionStorage.getItem("waitingPay") && pOrder[idx] === "payment") {
        this.isRegPage = true;
        this.save();
        return false;
      }

      if (this.isFinishPage || this.isRegPage) {
        this.save();
      } else {
        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
        var idx = pOrder.indexOf("input") + 1;
        sessionStorage.setItem("step", pOrder[idx]);
        this.$router.push(`/user/reg/${pOrder[idx]}`);
      }
    },

    // 수강신청 전체 데이터 저장
    async save() {
      this.is_loading = true;
      var classData = JSON.parse(sessionStorage.getItem("classData"));
      // console.log('classData', classData)
      //   var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));
      classData["idxItmSugangPageMain"] = sessionStorage.getItem("pageIdx");

      classData["payStatus"] = "X";

      var itemNames = [
        "이름",
        "비밀번호",
        "사번",
        "휴대전화번호",
        "직급",
        "부서",
        "회사",
        "공인시험점수",
      ];
      var count = 1;

      for (var item of classData["info"]) {
        if (item.item_name.includes("E-mail@")) {
          continue;
        } else if (itemNames.includes(item.item_name)) {
          continue;
        } else {
          classData["optionName" + count.toString()] = item.item_name;
          classData["optionContents" + count.toString()] = item.value;
          count += 1;
        }
      }

      delete classData["info"];

      classData["type"] = "Y";
      classData["studentSubjectIdx"] = -1;
      if (classData.classList) {
        delete this.sessionData["totalPayment"];
        classData["programIdx"] = sessionStorage.getItem("programIdx");
      } else {
        classData["type"] = "N";
        classData["orderId"] = "";
        classData["classList"] = [];
      }

      let params = classData;

      let overlapParams = JSON.parse(JSON.stringify(classData));

      overlapParams["programIdx"] = sessionStorage.getItem("programIdx");

      // 중복체크 api
      await this.axios
        .post(
          this.axios.root + this.axios.port + "/user/check-subjectdup",
          overlapParams
        )
        .then((res) => {
          // console.log('res 중복체크', res)
          if (res.data.err === 0) {
            // 수강신청 최종 등록 api
            this.axios
              .post(this.axios.root + this.axios.port + "/user/apply", params)
              .then((res) => {
                if (res.data.err === 0) {
                  localStorage.setItem("accessToken", res.data.accessToken);
                  this.axios.defaults.headers.common["accessToken"] =
                    res.data.accessToken;
                  let waitList = [];

                  if (res.data.subjectList) {
                    sessionStorage.setItem(
                      "finishData",
                      JSON.stringify(res.data.subjectList)
                    );
                    waitList = res.data.subjectList.filter(
                      (item) => item.status === "Y"
                    );
                  }

                  if (waitList.length > 0) {
                    let returnStr = this.splitClassName(waitList);
                    alert(
                      `현재 신청해주신 ${returnStr} 에 대한 수강신청은 선착순 마감되어 “대기자“로 신청되었습니다. \n 수강 가능시 담당 매니저가 개별 연락 드릴 예정입니다`
                    );
                  } else {
                    alert("신청이 완료되었습니다.");
                  }

                  this.is_loading = false;
                  if (typeof window.socket !== "undefined") {
                    let isCon = window.socket.connected;
                    if (isCon == true) {
                      // alert("dis")
                      // this.$socket.emit("disconnecting")
                      window.socket.disconnect();
                    }
                  }

                  if (this.isFinishPage) {
                    this.$router.push("/user/applyList");
                  } else if (this.isRegPage) {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    if (pOrder[pOrder.length - 1] === "complete") {
                      this.$router.push("/user/reg/complete");
                    } else {
                      this.$router.push("/user/applyList");
                    }
                  }
                } else {
                  alert(res.data.result);
                  this.is_loading = false;
                }
              });
          } else {
            this.is_loading = false;
            alert(res.data.result);
            return false;
          }
        });

      // console.log('params', params)
    },

    /**
     * @description : 과목을 배열 => 문자열
     */
    splitClassName(waitList) {
      let str = "";
      for (let i = 0; i < waitList.length; i++) {
        if (i === waitList.length - 1) {
          str += waitList[i].subjectName;
        } else {
          str += waitList[i].subjectName + ",";
        }
      }

      return str;
    },
  },
};
</script>
